export default __webpack_public_path__ + "static/media/AlignCropBands.ae00468c.gif";